<script setup>
import {ref, onBeforeMount, watch, onBeforeUnmount} from "vue";
import axios from "axios";
import store from "@/store/store";

const emit = defineEmits(['refresh-requests']);

const selected_fields = ref({
  selected_status: null,
  selected_fitter: null,
  selected_manager: { manager_user_id: null },
  manager_comment: null,
  selected_request_kind: null,
  selected_request_type: { type_id: null },
  selected_area: { area_id: null, area_name: null },
  selected_street: { street_id: null },
  selected_house: { house_id: null, flats: null },
  selected_flat: {
    flat_number: null,
    client_id: null,
    is_intercom: null,
    is_phone: null,
    is_tv: null,
    is_video_sur: null,
    is_internet: null,
    phonenumber: null
  }
});

const error_message = ref();
watch(
    () => selected_fields.value.manager_comment,
    (newValue) => {
      if (newValue) {
        selected_fields.value.manager_comment = newValue.replace(/\n/g, ' ');
      }
    }
);
const props = defineProps({
  request_statuses: { type: Array, default: () => [] },
  fitters_list: { type: Array, default: () => [] },
  engineers_list: { type: Array, default: () => [] },
  managers_list: { type: Array, default: () => [] },
  areas_streets_array: { type: Array, default: () => [] },
  // request_kinds_types_array: { type: Array, default: () => [] },
});
const request_kinds_types_array = ref([
  {
    type_id: "d283461c-09b4-430d-b5bd-eba2033ecc54",
    type_name: "Отключение",
    kinds: [
      {
        "kind_id": "c0914713-498f-4d82-8469-7567b71ed411",
        "kind_name": "Отключение по дебиторской задолжености, Кабельное телевидение"
      }
    ]
  },
  {
    type_id: "754a15de-c6c9-448a-8487-e94bab389ace",
    type_name: "Расторжение",
    kinds: [
      {
        "kind_id": "ecbb918f-ac31-4ac0-90ef-3d8371428004",
        "kind_name": " Расторжение по заявление  КТВ"
      },
      {
        "kind_id": "2abdf582-de1b-459e-bc37-f9f57750c378",
        "kind_name": "Отключение по заявлению, Кабельное телевидение"
      },
      {
        "kind_id": "9ea1b162-ebcd-428d-91e1-a5ce26ddeaeb",
        "kind_name": "Расторжение по заявление  интернет"
      },
      {
        "kind_id": "2a22e5c7-7437-41de-b778-e4cea5798ba6",
        "kind_name": "Расторжение по заявление  ктв +интернет"
      },
      {
        "kind_id": "3679aef2-1e9d-4d19-921c-9ea7ad280481",
        "kind_name": "Расторжение по заявление  ктв +интернет+В/Н+В/Д"
      },
      {
        "kind_id": "b7704d49-733e-4ab8-ab1c-30c99697b4b1",
        "kind_name": "Расторжение по заявление  ктв +тел+интернет +В/Н+В/Д"
      },
      {
        "kind_id": "22ab0569-1517-4c30-958c-92afc241b8f6",
        "kind_name": "Расторжение по заявление  тел"
      },
      {
        "kind_id": "6a54eb54-1250-49b1-b5d0-55f24c17c90d",
        "kind_name": "Расторжение по инициативе Компании КТВ"
      },
      {
        "kind_id": "c3dd69ab-df15-446f-9261-0e52d4e6737d",
        "kind_name": "Расторжение по инициативе Компании интернет"
      },
      {
        "kind_id": "a610e2cb-fd3c-456b-b135-f96c6b4b41c8",
        "kind_name": "Расторжение по инициативе Компании интернет+ ктв"
      },
      {
        "kind_id": "1f512be8-1a9d-4885-8033-e7afaf85acfe",
        "kind_name": "Расторжение по инициативе Компании интернет+ ктв +В/Н+В/Д"
      },
      {
        "kind_id": "b0ddc099-b784-4a1c-8646-780444915738",
        "kind_name": "Расторжение по инициативе Компании интернет+ктв +тел+В/Н+В/Д"
      },
      {
        "kind_id": "d0c7e158-e181-42d1-a8ff-6da67846f24e",
        "kind_name": "Расторжение по инициативе Компании тел"
      }
    ]
  },
])
const addresses = ref(null);
const is_manager = ref(store.getters['profile/is_manager']);
const is_fitter = ref(store.getters['profile/is_fitter']);
const is_superuser = ref(store.getters['profile/is_superuser']);
const manager_abonent_id = ref(store.getters['profile/abonent']);

const disconnection_internet = ref(["9ea1b162-ebcd-428d-91e1-a5ce26ddeaeb", "c3dd69ab-df15-446f-9261-0e52d4e6737d"])

const fetchClientsAddresses = async () => {
  if (!selected_fields.value.selected_street.street_id) return;
  addresses.value = (await axios.get('clients_addresses_by_street/', {
    params: { street_id: selected_fields.value.selected_street.street_id }
  })).data;
};

const postRequest = async () => {
  try {
    selected_fields.value.selected_manager.manager_user_id = manager_abonent_id.value;

    await axios.post('request_details/', {
      area_id: selected_fields.value.selected_area.area_id,
      street_id: selected_fields.value.selected_street.street_id,
      house_id: selected_fields.value.selected_house.house_id,
      flat_number: selected_fields.value.selected_flat.flat_number,
      client_id: selected_fields.value.selected_flat.client_id,
      phone_number: selected_fields.value.selected_flat.phonenumber,
      manager_id: selected_fields.value.selected_manager.manager_user_id,
      manager_comment: selected_fields.value.manager_comment,
      fitter_id: selected_fields.value.selected_fitter,
      request_type_id: selected_fields.value.selected_request_type.type_id,
      request_kind_id: selected_fields.value.selected_request_kind,
      services: {
        "tv": selected_fields.value.selected_flat.is_tv,
        "pho": selected_fields.value.selected_flat.is_phone,
        "itc": selected_fields.value.selected_flat.is_intercom,
        "vid": selected_fields.value.selected_flat.is_video_sur,
        "int": selected_fields.value.selected_flat.is_internet,
      },
    });
    resetSelectedFields();
    emit('refresh-requests');
    closeModal();

  } catch (error) {
    if (error.response) {
      // Server responded with a status code outside 2xx range
      error_message.value = error.response.data.ошибка || "An error occurred";
    } else if (error.request) {
      // Request was made but no response received
      error_message.value = "No response from server";
    } else {
      // Something happened in setting up the request
      error_message.value = error.message;
    }
  }
};

const resetSelectedFields = () => {
  selected_fields.value = {
    selected_status: null,
    selected_fitter: null,
    selected_manager: { manager_user_id: null },
    manager_comment: null,
    selected_request_kind: null,
    selected_request_type: { type_id: null },
    selected_area: { area_id: null, area_name: null },
    selected_street: { street_id: null },
    selected_house: { house_id: null, flats: null },
    selected_flat: { flat_number: null, client_id: null },
    services: null
  };
  error_message.value = ''
};



const openModal = () => {
  if(!is_manager){
    alert("Недостаточно прав!")
    return
  }
  const modal = new bootstrap.Modal(document.getElementById('new_request'));
  modal.show();
  history.pushState({modalOpen: true}, '');
};
const closeModal = () => {
  const modal = bootstrap.Modal.getInstance(document.getElementById('new_request'))
  if (modal) {
    modal.hide();
    history.replaceState(null, null);
  }
}
const handlePopState = (event) => {
  if (event.state && event.state.modalOpen) {
    closeModal();
  } else {
    history.replaceState(null, null);
  }
};
window.addEventListener('popstate', handlePopState);
onBeforeMount(() => {
  is_fitter.value = store.getters['profile/is_fitter'];
  is_manager.value = store.getters['profile/is_manager'];
  is_superuser.value = store.getters['profile/is_superuser'];
  manager_abonent_id.value = store.getters['profile/abonent'];
});
onBeforeUnmount(() => {
  // Remove the event listener when the component is destroyed
  window.removeEventListener('popstate', handlePopState);
});
</script>

<template>
  <div>
    <div v-if="is_manager">
      <button
          @click="openModal"
          class="btn btn-sm btn-primary ms-1"
          aria-label="Создать заявку на отключение"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Создать новую заявку"
      >
        <i class="fas fa-plus"></i>

      </button>
    </div>

    <div class="modal fade" id="new_request" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title text-bold">Создание заявки</h4>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="resetSelectedFields"></button>
          </div>
          <div class="modal-body">
            <!-- Area and Street Row -->
            <div class="row mb-3">
              <div class="col-12 col-md-5 mb-2 mb-md-0">
                <label class="form-label">Участок:</label>
                <select class="form-select" v-model="selected_fields.selected_area" required>
                  <option selected disabled>Выберите Участок</option>
                  <option v-for="(area, index) in areas_streets_array" :key="index" :value="area">
                    {{ area.area_name }}
                  </option>
                </select>
              </div>
              <div class="col-12 col-md-5 offset-md-1" v-if="selected_fields.selected_area">
                <label class="form-label">Улица:</label>
                <select class="form-select" v-model="selected_fields.selected_street" @change="fetchClientsAddresses" required>
                  <option selected disabled>Выберите улицу</option>
                  <option v-for="street in selected_fields.selected_area.streets" :key="street.street_id" :value="street">
                    {{ street.street_name }}
                  </option>
                </select>
              </div>
            </div>

            <!-- House and Flat Row -->
            <div class="row mb-3" v-if="addresses && addresses.length > 0">
              <div class="col-12 col-md-5 mb-2 mb-md-0">
                <label class="form-label">Дом:</label>
                <select class="form-select" v-model="selected_fields.selected_house" required>
                  <option v-for="(house, index) in addresses" :key="index" :value="house">
                    {{ house.house_number }}
                  </option>
                </select>
              </div>
              <div class="col-12 col-md-5 offset-md-1" v-if="selected_fields.selected_house">
                <label class="form-label">Квартира:</label>
                <select class="form-select" v-model="selected_fields.selected_flat" required>
                  <option v-for="(flat, index) in selected_fields.selected_house.flats" :key="index" :value="flat">
                    {{ flat.flat_number }}
                  </option>
                </select>
              </div>
            </div>

            <!-- Client Info -->
            <div v-if="selected_fields.selected_flat.client_id !== null">
              <div class="row mb-3">
                <div class="col-12 col-md-5 mb-2 mb-md-0">
                  <label class="form-label">ФИО абонента:</label>
                  <p class="text-sm">{{ selected_fields.selected_flat.lastname }} {{ selected_fields.selected_flat.firstname }} {{ selected_fields.selected_flat.middlename }}</p>
                </div>
                <div class="col-12 col-md-5 offset-md-1">
                  <label class="form-label">Телефон:</label>
                  <input type="text" class="form-control text-sm" v-model="selected_fields.selected_flat.phonenumber" required>
                </div>
              </div>
            </div>

            <!-- Request Type and Kind -->
            <div class="row mb-3">
              <div class="col-12 col-md-5 mb-2 mb-md-0">
                <label class="form-label">Вид:</label>
                <select class="form-select" v-model="selected_fields.selected_request_type">
                  <option v-for="type in request_kinds_types_array" :value="type" :key="type.type_id">
                    {{ type.type_name }}
                  </option>
                </select>
              </div>
              <div class="col-12 col-md-5 offset-md-1" :class="{'fade': !selected_fields.selected_request_type}">
                <label class="form-label">Причина:</label>
                <select class="form-select" v-model="selected_fields.selected_request_kind">
                  <option :disabled="!selected_fields.selected_request_type" v-for="kind in selected_fields.selected_request_type.kinds" :key="kind.kind_id" :value="kind.kind_id">
                    {{ kind.kind_name }}
                  </option>
                </select>
              </div>
            </div>
            <div
                class="row mb-3"
            >
              <div
                  class="col-12"
                  v-if="
                  (selected_fields.selected_request_type.type_id === 'd283461c-09b4-430d-b5bd-eba2033ecc54' || selected_fields.selected_request_type.type_id === '754a15de-c6c9-448a-8487-e94bab389ace') && selected_fields.selected_flat.client_id !== null"
              >
                <div class="d-flex flex-wrap gap-2">
                  <label class="h4 w-100">Выберите услуги на отключение:</label>
                  <!-- Internet -->
                  <button
                      type="button"
                      class="btn d-flex align-items-center gap-2"
                      :class="{
                        'btn-success': selected_fields.selected_flat.is_internet,
                        'btn-danger': !selected_fields.selected_flat.is_internet
                      }"
                      @click.prevent="selected_fields.selected_flat.is_internet = false"
                  >
                    <i class="fas fa-wifi"></i>
                    <span>Интернет</span>
                  </button>

                  <!-- Intercom -->
                  <button
                      type="button"
                      class="btn d-flex align-items-center gap-2"
                      :class="{
                        'btn-success': selected_fields.selected_flat.is_intercom,
                        'btn-danger': !selected_fields.selected_flat.is_intercom
                      }"
                      @click.prevent="selected_fields.selected_flat.is_intercom = false"
                  >
                    <i class="fas fa-door-closed"></i>
                    <span>Домофон</span>
                  </button>

                  <!-- Video Surveillance -->
                  <button
                      type="button"
                      class="btn d-flex align-items-center gap-2"
                      :class="{
                        'btn-success': selected_fields.selected_flat.is_video_sur,
                        'btn-danger': !selected_fields.selected_flat.is_video_sur
                      }"
                      @click.prevent="selected_fields.selected_flat.is_video_sur = false"
                  >
                    <i class="fas fa-video"></i>
                    <span>Видеонаблюдение</span>
                  </button>

                  <!-- Phone -->
                  <button
                      type="button"
                      class="btn d-flex align-items-center gap-2"
                      :class="{
                        'btn-success': selected_fields.selected_flat.is_phone,
                        'btn-danger': !selected_fields.selected_flat.is_phone
                      }"
                      @click.prevent="selected_fields.selected_flat.is_phone = false"
                  >
                    <i class="fas fa-phone-alt"></i>
                    <span>Телефония</span>
                  </button>

                  <!-- TV -->
                  <button
                      type="button"
                      class="btn d-flex align-items-center gap-2"
                      :class="{
                        'btn-success': selected_fields.selected_flat.is_tv,
                        'btn-danger': !selected_fields.selected_flat.is_tv
                      }"
                      @click.prevent="selected_fields.selected_flat.is_tv = false"
                  >
                    <i class="fas fa-tv"></i>
                    <span>Телевидение</span>
                  </button>
                </div>
              </div>
            </div>
            <!-- Manager and Fitter -->
            <div class="row mb-3">
              <div class="col-12 col-md-5 mb-2 mb-md-0">
                <label class="form-label">Менеджер:</label>
                <select class="form-select" disabled>
                  <option v-for="manager in managers_list.filter(m => m.manager_user_id === manager_abonent_id)" :key="manager.manager_user_id" :value="manager" selected>
                    {{ manager.manager_name }}
                  </option>
                </select>
              </div>
              <div class="col-12 col-md-5 offset-md-1" v-if="!disconnection_internet.includes(selected_fields.selected_request_kind)">
                <label class="form-label">Передать монтёру:</label>
                <select class="form-select" v-model="selected_fields.selected_fitter" required>
                  <option v-for="fitter in fitters_list" :key="fitter.fitter_id" :value="fitter.fitter_id">
                    {{ fitter.fitter_name }}
                  </option>
                </select>
              </div>
            </div>

            <!-- Manager Comment -->
            <div class="mb-3">
              <label class="form-label">Комментарий менеджера:</label>
              <textarea class="form-control" style="white-space: pre-wrap;" required v-model="selected_fields.manager_comment"></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <div class="container d-flex justify-content-end">
              <p class="me-auto text-bold text-danger"  v-if="error_message !== ''">{{error_message}}</p>
              <button class="btn btn-sm btn-primary" @click="postRequest" type="submit">Создать заявку</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.feature-toggle {
  border: 2px solid #dee2e6;
  background-color: #f8f9fa;
  border-radius: 1rem;
  width: 100px;
  height: 100px;
  transition: all 0.3s ease;
  color: #6c757d;
}

.feature-toggle .icon {
  font-size: 1.8rem;
}

.feature-toggle.active {
  background-color: #198754;
  border-color: #198754;
  color: white;
}

.feature-toggle.active .icon {
  color: white;
}

.feature-toggle:hover {
  transform: translateY(-2px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
}

</style>